export default __webpack_public_path__ + "static/media/cross.cdc3eebf.svg";